import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/machineD1.png'
import _imports_1 from '@/assets/machineD2.png'


const _hoisted_1 = { style: {"width":"250px"} }
const _hoisted_2 = {
  key: 1,
  class: "flex-1 ml-7"
}
const _hoisted_3 = { class: "w-full flex items-center" }
const _hoisted_4 = { style: {"font-size":"24px"} }
const _hoisted_5 = { class: "w-full flex mt-7" }
const _hoisted_6 = { style: {"min-width":"400px"} }
const _hoisted_7 = {
  class: "flex-col mt-2 w-full rounded-xl",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "box2" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { style: {"text-align":"center"} }
const _hoisted_12 = { class: "box2 ml-5" }
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { style: {"text-align":"center"} }
const _hoisted_15 = {
  class: "flex-col mt-2 w-full rounded-xl",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_16 = { class: "flex items-center ml-4 mt-4 mb-4" }
const _hoisted_17 = { style: {"font-size":"20px"} }
const _hoisted_18 = { class: "w-full flex flex-wrap mt-4" }
const _hoisted_19 = { class: "w-1/2" }
const _hoisted_20 = { style: {"opacity":"0.8"} }
const _hoisted_21 = { class: "w-1/2" }
const _hoisted_22 = { style: {"opacity":"0.8"} }
const _hoisted_23 = { class: "w-1/2 mt-2" }
const _hoisted_24 = { style: {"opacity":"0.8"} }
const _hoisted_25 = { class: "w-1/2 mt-2" }
const _hoisted_26 = { style: {"opacity":"0.8"} }
const _hoisted_27 = {
  class: "flex-col mt-2 w-full rounded-xl",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_28 = { class: "w-full flex items-center" }
const _hoisted_29 = { class: "flex items-center ml-4 mt-4 mb-4" }
const _hoisted_30 = { style: {"font-size":"20px"} }
const _hoisted_31 = { class: "w-full flex items-center" }
const _hoisted_32 = { class: "ml-2" }
const _hoisted_33 = { class: "w-full flex items-center" }
const _hoisted_34 = { class: "ml-2" }
const _hoisted_35 = { class: "w-full flex mt-4" }
const _hoisted_36 = {
  class: "flex-1 flex flex-col",
  style: {"height":"290px"}
}
const _hoisted_37 = { class: "flex-1 mt-4" }
const _hoisted_38 = {
  key: 0,
  id: "chartAM",
  style: {"height":"200px","width":"200px"}
}
const _hoisted_39 = {
  class: "w-full",
  style: {"text-align":"center"}
}
const _hoisted_40 = { style: {"color":"#03b503ff"} }
const _hoisted_41 = { class: "ml-4" }
const _hoisted_42 = {
  class: "flex items-center",
  style: {"font-size":"16px"}
}
const _hoisted_43 = { class: "ml-2" }
const _hoisted_44 = { class: "ml-2" }
const _hoisted_45 = {
  class: "flex items-center",
  style: {"font-size":"13px"}
}
const _hoisted_46 = { class: "ml-2 opt8" }
const _hoisted_47 = { class: "ml-2 opt8" }
const _hoisted_48 = { class: "mt-4" }
const _hoisted_49 = {
  class: "flex items-center",
  style: {"font-size":"16px"}
}
const _hoisted_50 = { class: "ml-2" }
const _hoisted_51 = { class: "ml-2" }
const _hoisted_52 = {
  class: "flex items-center",
  style: {"font-size":"13px"}
}
const _hoisted_53 = { class: "ml-2 opt8" }
const _hoisted_54 = { class: "ml-2 opt8" }
const _hoisted_55 = { class: "mt-4" }
const _hoisted_56 = {
  class: "flex items-center",
  style: {"font-size":"16px"}
}
const _hoisted_57 = { class: "ml-2" }
const _hoisted_58 = { class: "ml-2" }
const _hoisted_59 = {
  class: "flex items-center",
  style: {"font-size":"13px"}
}
const _hoisted_60 = { class: "ml-2 opt8" }
const _hoisted_61 = { class: "ml-2 opt8" }
const _hoisted_62 = { class: "mt-4" }
const _hoisted_63 = {
  class: "flex items-center",
  style: {"font-size":"16px"}
}
const _hoisted_64 = { class: "ml-2" }
const _hoisted_65 = { class: "ml-2" }
const _hoisted_66 = {
  class: "flex items-center",
  style: {"font-size":"13px"}
}
const _hoisted_67 = { class: "ml-2 opt8" }
const _hoisted_68 = { class: "ml-2 opt8" }
const _hoisted_69 = { class: "mt-4" }
const _hoisted_70 = {
  class: "flex items-center",
  style: {"font-size":"16px"}
}
const _hoisted_71 = { class: "ml-2" }
const _hoisted_72 = { class: "ml-2" }
const _hoisted_73 = {
  class: "flex items-center",
  style: {"font-size":"13px"}
}
const _hoisted_74 = { class: "ml-2 opt8" }
const _hoisted_75 = { class: "ml-2 opt8" }
const _hoisted_76 = {
  class: "flex-col ml-6 mt-2 w-full rounded-xl",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_77 = { class: "w-full flex" }
const _hoisted_78 = { class: "flex items-center mr-8" }
const _hoisted_79 = { class: "ml-2" }
const _hoisted_80 = { class: "ml-2" }
const _hoisted_81 = { class: "ml-2" }
const _hoisted_82 = { class: "ml-2" }
const _hoisted_83 = {
  key: 1,
  id: "yulan",
  style: {"margin":"auto","padding":"20px","width":"800px","height":"600px","position":"relative"}
}
const _hoisted_84 = ["src"]
const _hoisted_85 = {
  class: "w-full",
  style: {"padding":"5px 10px"}
}
const _hoisted_86 = { class: "w-full flex" }
const _hoisted_87 = { class: "w-full flex items-center" }
const _hoisted_88 = {
  key: 0,
  style: {"width":"35%"}
}
const _hoisted_89 = { style: {"font-size":"12px","opacity":"0.6"} }
const _hoisted_90 = {
  key: 1,
  style: {"width":"35%"}
}
const _hoisted_91 = { style: {"font-size":"12px","opacity":"0.6"} }
const _hoisted_92 = {
  key: 2,
  style: {"width":"30%","word-wrap":"break-word"}
}
const _hoisted_93 = { style: {"font-size":"12px","opacity":"0.6"} }
const _hoisted_94 = { class: "w-full flex" }
const _hoisted_95 = {
  class: "mr-2",
  style: {"font-size":"12px","opacity":"0.6"}
}
const _hoisted_96 = {
  class: "flex-col ml-6 mt-2 w-full rounded-xl",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_97 = { class: "w-full flex items-center ml-4 mt-4 mb-4" }
const _hoisted_98 = { class: "size18 ml-2" }
const _hoisted_99 = { class: "w-full flex items-center justify-between mt-2" }
const _hoisted_100 = { class: "w-full flex" }
const _hoisted_101 = {
  key: 0,
  id: "chartMachienB",
  style: {"width":"290px","height":"290px"}
}
const _hoisted_102 = {
  class: "flex-col mt-6 ml-6 w-full rounded-xl",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_103 = {
  key: 2,
  class: "flex-1 ml-7"
}
const _hoisted_104 = { class: "w-full flex items-center" }
const _hoisted_105 = { style: {"font-size":"24px"} }
const _hoisted_106 = { class: "w-full flex" }
const _hoisted_107 = {
  class: "w-full flex items-center",
  style: {"border-bottom":"1px solid #ffc000"}
}
const _hoisted_108 = { class: "ml-3" }
const _hoisted_109 = { class: "mt-2 w-full flex items-center" }
const _hoisted_110 = { class: "pic" }
const _hoisted_111 = ["src"]
const _hoisted_112 = { class: "flex-1 ml-4" }
const _hoisted_113 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_114 = { class: "text-gray-50 pl-2" }
const _hoisted_115 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_116 = { class: "text-gray-50 pl-2" }
const _hoisted_117 = { class: "flex items-center mt-2" }
const _hoisted_118 = { class: "text-gray-50 pl-2" }
const _hoisted_119 = { class: "flex-1 flex" }
const _hoisted_120 = { style: {"width":"80%","display":"flex","justify-content":"center","position":"relative"} }
const _hoisted_121 = {
  key: 0,
  id: "yulan",
  style: {"margin":"auto","padding":"20px","width":"1000px","height":"800px","position":"relative"}
}
const _hoisted_122 = ["src"]
const _hoisted_123 = {
  class: "w-full",
  style: {"padding":"5px 10px"}
}
const _hoisted_124 = { class: "w-full flex" }
const _hoisted_125 = { style: {"font-size":"18px"} }

import { ref } from "vue";
import { useRouter } from "vue-router";
import request from "../../common/request";
import { v4 as uuidv4 } from "uuid";
import machineListLeftComponent from "../components/machine-list-left.vue";
import pictureListComponent from "../components/picture-list.vue";
import { langList } from "../../common/lang";
import {
  transformDate,
  transformDate2,
  getGroupName,
} from "../../common/tools";
import * as echarts from "echarts";
import { getLanguage, getTranslation } from "../../common/translate"
import WorkflowWidget from "@/components/dashboard/workflow-widget.vue";
import D3dViewer from "../components/d3d-viewer.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'machine',
  setup(__props) {

let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
  langObj.value = langList[language.value]
}
getLang()

const router = useRouter();
let machine_id = "";
let machineInfo: any = ref({});

let conditionList = [
  { label: "健康", value: [0], color: "#61c08f", color2: "#3a3a3aff" },
  { label: "可用", value: [1, 2], color: "#706a00ff", color2: "#706a00ff" },
  { label: "警戒", value: [3, 4, 5], color: "#cd5f3b", color2: "#cd5f3b" },
  { label: "故障", value: [6, 7], color: "#921e37", color2: "#921e37" },
];

const getColor = (ev: any) => {
  let a = conditionList.find((p: any) => p.value.includes(ev));
  return a ? a.color2 : "#171325ff";
};

const getColor2 = (ev: any) => {
  let a: any = conditionList.find((p: any) => p.value.includes(ev));
  return a?.color;
};

const getShadow = (ev: any) => {
  // box-shadow: inset 0 0 34px 0 #171325ff;
  let a = conditionList.find((p: any) => p.value.includes(ev));
  let c = a ? a.color2 : "#171325ff";

  return "inset 0 0 34px 0 " + c;
};

// let conditionLists = [
//     {label: '健康', value: 0, color: '#61c08f'},
//     {label: '可用', value: 1, color: '#706a00ff'},
//     {label: '可用', value: 2, color: '#706a00ff'},
//     {label: '警戒', value: 3, color: '#cd5f3b'},
//     {label: '警戒', value: 4, color: '#cd5f3b'},
//     {label: '警戒', value: 5, color: '#cd5f3b'},
//     {label: '故障', value: 6, color: '#921e37'},
//     {label: '故障', value: 7, color: '#921e37'},
// ]

let statusList = [
  { label: "停机", value: 0, color: "#ADADAD" },
  { label: "运行", value: 1, color: "#03b503ff" },
];

let selectType: any = ref(1)

const selectMachine = (ev: any) => {
  selectType.value = 1
  machine_id = ev;
  selecrRandar.value = 2;
  picListAll.value = [];
  picList.value = [];
  init();
};

const init = () => {
  getMachineInfo();
  getMachineStatusTime();
};

// 获取设备详情
const getMachineInfo = async () => {
  let config: any = {
    params: {
      machineId: machine_id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  let result = await request.get("/api/machines/info", config);

  if (result) {
    machineInfo.value = result.data || { sort: 999 };
    if (
      machineInfo.value &&
      machineInfo.value.workStatus &&
      machineInfo.value.workStatus.stableCondition
    ) {
      machineInfo.value.condition = conditionList.find((p: any) =>
        p.value.includes(machineInfo.value.workStatus.stableCondition)
      );
    } else {
      machineInfo.value.condition = conditionList[0];
    }

    if (
      machineInfo.value &&
      machineInfo.value.workStatus &&
      machineInfo.value.workStatus.scoreWkStatus
    ) {
      machineInfo.value.status = statusList.find(
        (p: any) => p.value === machineInfo.value.workStatus.scoreWkStatus
      );
    } else {
      machineInfo.value.status = statusList[0];
    }
    load3D();
  }

  if (machineInfo.value.pictures?.length > 0) {
    picList.value.push({
      name: "设备",
      url: machineInfo.value.pictures[0].url,
    });
  }
  getSensorList();
  getRandarChartData();
};

let picList: any = ref([]);
let picListAll: any = ref([]);
const getSensorList = async () => {
  let config: any = {
    params: {
      machineId: machine_id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  let result = await request.get("/api/sensors", config);

  if (result && result.status === 200) {
    result.data.map((d: any) => {
      if (d.pictures) {
        d.pictures.map((p: any) => {
          picList.value.push({
            name: d.sensorPlace,
            url: p.url
          })
        })
      }
    });
  }

  picListAll.value = picList.value;
};

// 获取设备状态占比
let satusTimeDate: any = ref(1);
let visibleChart = ref(true);
let conditionTotal: any = ref({
  condition1Date: "--",
  condition2Date: "--",
  condition3Date: "--",
  condition4Date: "--",
  condition1Rate: 0,
  condition2Rate: 0,
  condition3Rate: 0,
  condition4Rate: 0,
  wkStatus1Date: "--",
  wkStatus2Date: "--",
  wkStatus1Rate: 0,
  wkStatus2Rate: 0,
});
const getMachineStatusTime = async () => {
  conditionTotal.value = {
    condition1Date: "--",
    condition2Date: "--",
    condition3Date: "--",
    condition4Date: "--",
    condition1Rate: 0,
    condition2Rate: 0,
    condition3Rate: 0,
    condition4Rate: 0,
    wkStatus1Date: "--",
    wkStatus2Date: "--",
    wkStatus1Rate: 0,
    wkStatus2Rate: 0,
  };
  let time = new Date();
  let endDate = transformDate2(time, 1);


  // satusTimeDate.value = 3;
  // //本年
  // if (satusTimeDate.value === 3) {
  //   startDate = `${year}/01/01 00:00:00`;
  // }
  //本月
  let num = satusTimeDate.value === 2 ? 30 : 7

  let startTime = time.getTime() - (1000 * 60 * 60 * 24 * num)
  let startDate = transformDate2(startTime, 1)


  let stableSearch = {
    params: {
      begin: startDate,
      end: endDate,
      machineId: machine_id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  let result2 = await request.get(
    "/api/machines/workstatus/stables",
    stableSearch
  );
  let stableList: any = [];
  if (result2 && result2.data && result2.data.length) {
    stableList = result2.data;
  }

  let beginT = new Date(startDate).getTime();
  let endT = new Date(endDate).getTime();

  let condition0 = 0; //无
  let condition1 = 0; //健康
  let condition2 = 0; //可用
  let condition3 = 0; //警戒
  let condition4 = 0; //故障
  let conditionT = endT - beginT;
  let dateRangeTotal = endT - beginT;
  if (stableList?.length > 0) {
    if (stableList.length > 1) {
      conditionT = new Date(stableList[stableList.length - 1].date).getTime() - new Date(stableList[0].date).getTime();
    }
    stableList.map((d: any, index: any) => {
      if (index == 0) {
        condition0 = new Date(d.date).getTime() - beginT;
      } else {
        let time =
          new Date(d.date).getTime() -
          new Date(stableList[index - 1].date).getTime();

        if (d.condition === 0) {
          condition1 = condition1 + time;
        }
        if (d.condition >= 1 && d.condition <= 2) {
          condition2 = condition2 + time;
        }
        if (d.condition >= 3 && d.condition <= 5) {
          condition3 = condition3 + time;
        }
        if (d.condition >= 6 && d.condition <= 7) {
          condition4 = condition4 + time;
        }
      }

      if (index === stableList.length - 1) {
        condition0 = condition0 + (endT - new Date(d.date).getTime());
      }
    });
  } else {
    condition1 = 0
    condition2 = 0
    condition3 = 0
    condition4 = 0
    condition0 = conditionT
  }


  let result4 = await request.get('/api/external/machines/onlines', stableSearch)
  let wkStatus1 = 0; //运行
  let wkStatus2 = 0; //停机
  let dateWK1 = 0
  if (result4 && result4.data) {
    result4.data.map((d: any) => {
      dateWK1 = dateWK1 + Math.round(d.online / 3600)
    })
  }
  wkStatus1 = dateWK1 * 60 * 60 * 1000
  wkStatus2 = conditionT - wkStatus1

  function convertTimestamp(timestamp: any) {
    var milliseconds = timestamp;
    var date: any = new Date(milliseconds);

    var days = Math.floor(date / (24 * 60 * 60 * 1000));
    var hours = Math.floor((date % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    var minutes = Math.floor((date % (60 * 60 * 1000)) / (60 * 1000));
    return days + getLanguage("天", language.value) + ' ' + hours + getLanguage("时", language.value) + ' ' + minutes + getLanguage("分", language.value);
  }

  conditionTotal.value = {
    condition1Date: convertTimestamp(condition1),
    condition2Date: convertTimestamp(condition2),
    condition3Date: convertTimestamp(condition3),
    condition4Date: convertTimestamp(condition4),
    condition0Rate: Number(((condition0 / conditionT) * 100).toFixed(0)),
    condition1Rate: Number(((condition1 / conditionT) * 100).toFixed(0)),
    condition2Rate: Number(((condition2 / conditionT) * 100).toFixed(0)),
    condition3Rate: Number(((condition3 / conditionT) * 100).toFixed(0)),
    condition4Rate: Number(((condition4 / conditionT) * 100).toFixed(0)),
    wkStatus1Rate: Number(((wkStatus1 / dateRangeTotal) * 100).toFixed(0)),
    wkStatus2Rate: Number(
      (((wkStatus2) / dateRangeTotal) * 100).toFixed(0)
    ),
    wkStatus1Date: convertTimestamp(wkStatus1),
    wkStatus2Date: convertTimestamp(wkStatus2),
    wkStatsu: convertTimestamp(wkStatus1)
  };

  visibleChart.value = false;
  visibleChart.value = true;

  setTimeout(() => {
    initMacineStatusRateChart();
  }, 500);
};

//绘制设备状态占比图
const initMacineStatusRateChart = () => {
  const ec = echarts as any;
  if (!document.getElementById("chartAM")) return;
  let myChart = ec.init(document.getElementById("chartAM"));

  const data = [
    {
      name: "外层饼图",
      children: [
        { value: conditionTotal.value.condition1Rate, name: "健康" },
        { value: conditionTotal.value.condition2Rate, name: "可用" },
        { value: conditionTotal.value.condition3Rate, name: "警戒" },
        { value: conditionTotal.value.condition4Rate, name: "故障" },
        { value: conditionTotal.value.condition0Rate, name: "停机" },
      ],
    },
    {
      name: "内层饼图",
      children: [
        { value: conditionTotal.value.wkStatus1Rate, name: "运行" },
        { value: conditionTotal.value.wkStatus2Rate, name: "停机" },
      ],
    },
  ];

  // 配置选项
  const option = {
    color: ["#1CC48B", "#DDD246", "#CB6A34", "#B81212", "#ADADB0"],
    grid: {
      right: "0%",
      left: "0%",
      top: 0,
      bottom: 0,
    },
    series: [
      {
        name: "外层饼图",
        type: "pie",
        radius: ["70%", "100%"], // 控制内外半径
        label: {
          show: false, // 不显示标签
        },
        data: data[0].children,
        emphasis: {
          scale: false, // 取消鼠标移入放大效果
        },
      },
      {
        name: "内层饼图",
        type: "pie",
        radius: ["40%", "70%"], // 控制内外半径
        label: {
          show: false, // 不显示标签
        },
        data: data[1].children,
        color: ["#4DFAED", "#ADADB0"],
        emphasis: {
          scale: false, // 取消鼠标移入放大效果
        },
      },
    ],
  };

  // 使用配置项显示图表
  myChart.setOption(option);
};

// 获取雷达图数据
let selecrRandar = ref(2); //1健康  2振动
let visibleChart2 = ref(true);
const getRandarChartData = async () => {
  let faultnamesSearch = {
    params: { machineId: machine_id },
    headers: {
      requestId: uuidv4(),
    },
  };
  let result = await request.get("/api/machines/faultnames", faultnamesSearch);
  let faultName = result.data.faultNames;
  let faultNameII = result.data.faultNameExpects;

  let Slist: any = [];
  let Tlist: any = [];

  if (
    machineInfo.value.workStatus &&
    machineInfo.value.workStatus.stableScores
  ) {
    for (let index in machineInfo.value.workStatus.stableScores) {
      const item = machineInfo.value.workStatus.stableScores[index];
      if (index.includes("S")) {
        Slist.push({
          quota: index,
          score: item,
          text: langObj.value[faultName.find((p: any) => p.column === index)?.title] || faultName.find((p: any) => p.column === index)?.title,
        });
      }

      if (index.includes("T")) {
        Tlist.push({
          quota: index,
          score: item,
          text: langObj.value[faultNameII.find((p: any) => p.column === index)?.title] || faultNameII.find((p: any) => p.column === index)?.title,
        });
      }
    }
  }

  machineInfo.value.Tlist = Tlist;
  machineInfo.value.Slist = Slist;

  // 获取分数趋势数据
  let end = transformDate(new Date());
  let begin = transformDate(new Date().getTime() - 1000 * 60 * 60 * 24);

  let search = {
    params: {
      begin,
      end,
      sensorId: "",
      machineId: machine_id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  let score = await request.get("/api/external/machines/score", search);
  let scoreAll = score.data;
  let scoreExpert = await request.get(
    "/api/external/machines/score-expert",
    search
  );
  let scoreExpertAll = scoreExpert.data;

  let date1 = scoreAll.map((d: any) => d.date);
  let date2 = scoreExpertAll.map((d: any) => d.date);

  let date = [...date1, ...date2];
  date = [...new Set(date)].sort();

  let scoreDataList: any = [];

  date.map((d: any) => {
    let info1 = scoreAll.find((p: any) => p.date === d);
    let info2 = scoreExpertAll.find((p: any) => p.date === d);

    let score = 0;

    let list1: any[] = [];
    if (info1) {
      delete info1.date;
      delete info1.wkStatus;
      list1 = Object.values(info1).sort();
    }

    let list2: any[] = []
    if (info2) {
      delete info2.date;
      delete info2.wkStatus;
      list2 = Object.values(info2).sort();
    }

    let a: any = 0;
    let b: any = 0;
    if (list1 && list1.length) {
      a = list1[0];
    }
    if (list2 && list2.length) {
      b = list2[0];
    }
    if (a >= b) {
      score = b;
    } else {
      score = a;
    }

    scoreDataList.push({
      date: d,
      value: score,
    });
  });
  machineInfo.value.scoreDataList = scoreDataList;

  visibleChart2.value = false;
  visibleChart2.value = true;

  setTimeout(() => {
    if (selecrRandar.value === 1) {
      initRandarChart(Slist);
    }
    if (selecrRandar.value === 2) {
      initRandarChart(Tlist);
    }
  }, 500);
};

// 绘制雷达图
const initRandarChart = (dataList: any) => {
  const ec = echarts as any;
  if (!document.getElementById("chartMachienB")) return;
  let myChart = ec.init(document.getElementById("chartMachienB"));
  myChart.clear();
  if (!dataList.length) return;
  let data: any = [];
  let error: any = [];
  let indicator: any = [];
  dataList.map((d: any) => {
    data.push(d.score);
    error.push(60);
    let color = "";
    if (d.score >= 0 && d.score < 60) {
      color = "#CD5F3B";
    }
    if (d.score >= 60 && d.score < 80) {
      color = "#706a00ff";
    }
    if (d.score >= 80 && d.score <= 100) {
      color = "#fff";
    }

    let name = ''
    if ((language.value == "Chinese" || language.value == "Chinese_ft") && d.text) {
      if (d.text.length > 8) {
        name = (d.text.substring(0, 4) + '\n' + d.text.substring(4, 8) + '\n' + d.text.substring(8, d.text.length))
      } else if (d.text.length > 4 && d.text.length <= 8) {
        name = d.text.substring(0, 4) + '\n' + d.text.substring(4, d.text.length)
      } else {
        name = d.text
      }
    }

    if (language.value == "English" && d.text) {
      let list1 = d.text.split(' ')

      let str: any = ''
      let num = 0
      let sy = ''
      list1.map((n: any, i: any) => {
        if (i == 0) {
          if (n.length <= 10) {
            num = n.length
            str = n
          } else {
            num = 10
            let a1 = n.substring(0, 10)
            sy = n.slice(10)
            str = a1
          }
        } else {

          if (sy) {
            str = str + '\n';
            let n2 = sy.length + n.length
            if (n2 <= 10) {
              num = n2
              str = str + sy + ' ' + n
              sy = ''
            } else {
              num = 10
              str = str + sy
              let n2 = 10 - sy.length >= 0 ? 10 - sy.length : 0

              let a1 = n.substring(0, n2)
              sy = n.slice(10)
              str = str + a1
            }
          } else {
            if (num + n.length <= 10) {
              str = str + ' ' + n
              num = num + n.length
            } else {
              str = str + '\n' + n
              num = n.length
            }
          }
        }
      })
      name = str
    }

    indicator.push({
      color,
      max: 100,
      text: name
    });
  });

  const option = {
    title: {
      text: "",
    },
    tooltip: { position: { left: '0px' } },
    radar: [
      {
        indicator: indicator,
        center: ["50%", "50%"],
        radius: 60,
        startAngle: 90,
        splitNumber: 5,
        name: {
          formatter: "{value}",
          textStyle: {
            color: "rgba(46, 214, 157, 1)",
            fontSize: 12,
          },
        },
        splitArea: {
          areaStyle: {
            color: ["#605969", "#453A47"],
          },
        },
        axisLine: {
          lineStyle: {
            color: "rgba(255, 255, 255, 0.1)",
          },
        },
        splitLine: {
          lineStyle: {
            color: ["rgb(241,243,250)"],
            width: 0,
          },
        },
      },
    ],
    series: [
      {
        name: "当前值",
        type: "radar",
        emphasis: {
          lineStyle: {
            width: 4,
          },
        },
        symbolSize: 2, // 拐点的大小
        data: [
          {
            value: data,
            lineStyle: {
              width: 1,
              color: "rgba(247,220,225,0.1)",
              normal: {
                type: "dotted",
              },
            },
            itemStyle: {
              color: "#FF4E13",
              borderWidth: 5,
            },
            areaStyle: {
              color: "#F7DCE1",
            },
          },
        ],
      },
      {
        name: "预警值",
        type: "radar",
        emphasis: {
          lineStyle: {
            width: 1,
          },
        },
        symbolSize: 2, // 拐点的大小
        data: [
          {
            value: error,
            name: "",
            lineStyle: {
              width: 2,
              color: "rgba(255, 25, 59, 0.2)",
            },
            itemStyle: {
              color: "rgba(255, 25, 59, 0.2)",
              borderWidth: 0,
            },
          },
        ],
      },
    ],
  };

  option && myChart.setOption(option);
};

//绘制分数趋势图
const initScoreChart = () => {
  let data = machineInfo.value.scoreDataList;
  const ec = echarts as any;
  if (!document.getElementById("chartMachienB")) return;
  let myChart = ec.init(document.getElementById("chartMachienB"));
  myChart.clear();
  let xData = data.map((p: any) => p.date);
  let yData = data.map((p: any) => p.value);

  let option = {
    color: ["#00d1c7ff"],
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
      },
    },
    toolbox: {
      trigger: "axis",
    },
    dataZoom: [{ type: "inside" }],
    xAxis: {
      type: "category",
      axisTick: {
        alignWithLabel: true,
      },
      axisLabel: {
        showMaxLabel: true,
      },
      splitLine: {
        show: true,
        lineStyle: {
          opacity: 0.3,
        },
      },
      data: xData,
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        data: yData,
        type: "line",
      },
    ],
  };

  myChart.setOption(option);
};

// 选择雷达图、分数趋势图
const selectTag = (ev: any) => {
  selecrRandar.value = ev;
  if (ev === 1) {
    initRandarChart(machineInfo.value.Slist);
  }

  if (ev === 2) {
    initRandarChart(machineInfo.value.Tlist);
  }

  if (ev === 3) {
    initScoreChart();
  }
};

// 获取3D图测点数据
const get3DData = async () => {
  let config2: any = {
    params: {
      machineId: machine_id,
    },

    headers: {
      requestId: uuidv4(),
    },
  };
  let result2 = await request.get("/api/sensors",config2);
  
  let senList2:any = result2?.data || []


  let config: any = {
    params: {
      id: machine_id,
    },

    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.get(
    "/api/external/machines/workstatus/info",
    config
  );

  if (result && result.data) {
    config_3d.value.marks?.map((d: any) => {
      if (d.bind.includes("b-")) {
        let list = d.bind.split("-");
        if (list && list.length === 2) {
          let sensorId = list[1];
          let sensorInfo = senList2.find(
            (p: any) => p.id === sensorId
          );
          if (sensorInfo) {
            d.sensorPlace = sensorInfo.sensorPlace;
            d.dataType = sensorInfo.dataType || []
          } else {
            d.sensorPlace = "";
            d.dataType = []
          }

          let info = result.data.quotas.find(
            (p: any) => p.sensorId === sensorId
          );
          if (info) {
            if (info.values.length) {
              let sz = info.values.find((p: any) => p.type === "速度Z");
              d.sz = sz ? sz.value.toFixed(2) : "0";
              let hz = info.values.find((p: any) => p.type === "高频加速度");
              d.hz = hz ? hz.value.toFixed(2) : "0";
              let temp = info.values.find((p: any) => p.type === "温度");
              d.temp = temp ? temp.value.toFixed(2) : "0";
            }
            d.date = info.date
          }
          let stableInfo = result.data.stableSensors && result.data.stableSensors.find(
            (p: any) => p.id === sensorId
          );
          if (stableInfo) {
            delete stableInfo.id;
            let list = Object.values(stableInfo).sort();
            let score: any = 100;
            if (list && list.length) {
              score = list[0];
            }

            if (score >= 80 && score <= 100) {
              d.condition = 0;
            }
            if (score >= 60 && score < 80) {
              d.condition = 1;
            }
            if (score >= 30 && score < 60) {
              d.condition = 3;
            }
            if (score >= 0 && score < 30) {
              d.condition = 6;
            }
          }
        }
      }
    });
  }
};

// 切换23d图
let switch23d:any = ref(false)
let isShowSwitch23d:any = ref(false)
const change23d = (ev:any) => {
  console.log('ev', ev)
}

const isShow3d = () => {
  let data = false
  if(isShowSwitch23d.value) {
    if(switch23d.value) {
      data = false
    } else {
      data = true
    }
  } else {
    if(config_4d.value) {
      data = true
    } else {
      data = false
    }
  }

  return data
}

const isShow2d = () => {
  let data = false
  if(isShowSwitch23d.value) {
    if(switch23d.value) {
      data = true
    } else {
      data = false
    }
  } else {
    if(config_3d.value && config_3d.value.img && !config_4d.value) {
      data = true
    } else {
      data = false
    }
  }
  return data
}

let markList = ref([]);

let config_3d = ref({
  marks: [],
});

let line = ref([]);
let config_4d:any = ref(null)
let isShow3DM:any = ref(false)
const load3D = async () => {
  isShow3DM.value = false
  config_3d.value = {};
  let config: any = {
    params: {
      machineId: machine_id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  let result2 = await request.get("/api/machine-3D", config);

  let result = result2.data.find((p:any) => p.type === '2d' || !p.type)
  config_4d.value = result2.data.find((p:any) => p.type === '3d') 
  if(result && config_4d.value) {
    isShowSwitch23d.value = true
  } else {
    isShowSwitch23d.value = false
  }

  isShow3DM.value = true
  if(result) {
    config_3d.value = result || {
      marks: [],
    };
    config_3d.value.marks = config_3d.value.marks || [];
    markList.value = config_3d.value.marks;
  }else {
    config_3d.value = {marks: []}
  }
  
  line.value = [];
  if (config_3d.value.marks?.length > 0) {
    for (var i = 0; i < config_3d.value.marks.length; i++) {
      var item = config_3d.value.marks[i];
      if (item.bind.indexOf("a-") > -1) {
        var find = config_3d.value.marks.find(
          (t) =>
            t.bind.substring(2, t.bind.length) ==
            item.bind.substring(2, item.bind.length) &&
            t.bind.indexOf("b-") > -1
        );
        if (find) {
          var distance = Math.sqrt(
            Math.pow(find.x - item.x, 2) + Math.pow(find.y - item.y, 2)
          );
          var angle_d =
            Math.atan2(find.y - item.y, find.x - item.x) * (180 / Math.PI);
          line.value.push({
            ...item,
            distance: distance,
            angle: angle_d,
          });
        }
      }
    }
  }

  get3DData();
};

// 是否展示
const isShowQuota = (dataType:any, type:any) => {
  if(!dataType) return false
  return dataType.includes(type)
}

// 选择区域
let group_info: any = ref({})
let group_machineList: any = ref([])
let config_3d_group: any = ref({})
let lineGroup: any = ref([])
let searchPage: any = ref({
  skip: 1,
  take: 5,
  total: 0
})
let group_machineList_page: any = ref([])

const selectGroup = (ev: any) => {
  selectType.value = 2
  if (ev) {
    group_info.value = ev
    group_machineList.value = ev.machineList || []
  } else {
    group_machineList.value = []
  }
  searchPage.value.skip = 1
  searchPage.value.total = group_machineList.value.length
  changePage(searchPage.value.skip, searchPage.value.take)
  loadGroup3D()
}

const changePage = (skip: any, take: any) => {
  searchPage.value.skip = skip
  group_machineList_page = group_machineList.value.slice((skip - 1) * take, skip * take)
}

const loadGroup3D = async () => {
  config_3d_group.value = { marks: [] };

  let config: any = {
    params: {
      groupId: group_info.value.id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.get("/api/group-3D", config);
  if (result?.data) {
    config_3d_group.value = result.data

    markList.value = config_3d_group.value.marks;
  }


  lineGroup.value = [];
  for (var i = 0; i < config_3d_group.value.marks.length; i++) {
    var item = config_3d_group.value.marks[i];
    if (item.bind.indexOf("a-") > -1) {
      var find = config_3d_group.value.marks.find(
        (t: any) =>
          t.bind.substring(2, t.bind.length) ==
          item.bind.substring(2, item.bind.length) &&
          t.bind.indexOf("b-") > -1
      );
      if (find) {
        var distance = Math.sqrt(
          Math.pow(find.x - item.x, 2) + Math.pow(find.y - item.y, 2)
        );
        var angle_d =
          Math.atan2(find.y - item.y, find.x - item.x) * (180 / Math.PI);
        lineGroup.value.push({
          ...item,
          distance: distance,
          angle: angle_d,
        });
      }
    }

  }
}

// 右键全屏
let menuVisible = ref(false)
let menuPosition: any = ref({
  top: 0,
  left: 0
})
const openContextMenu = (event: any) => {
  menuVisible.value = true
  menuPosition.value.top = `${event.clientY}px`
  menuPosition.value.left = `${event.clientX}px`
}

const fullS = () => {
  // 全屏
  menuVisible.value = false
  let element = document.getElementById('mainBox3')
  if (!element) return false
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) { /* Firefox */
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) { /* IE/Edge */
    element.msRequestFullscreen();
  }
}


return (_ctx: any,_cache: any) => {
  const _component_calendar_outlined = _resolveComponent("calendar-outlined")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: "w-full flex px-7 py-2",
    id: "mainBox3",
    onContextmenu: _withModifiers(openContextMenu, ["prevent"]),
    style: {"background-color":"#080718ff","color":"#fff","overflow-y":"scroll","height":"calc(100vh - 100px)"}
  }, [
    (_unref(menuVisible))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "context-menu",
          style: _normalizeStyle(_unref(menuPosition))
        }, [
          _createElementVNode("div", {
            class: "w-full cursor-pointer px-4 text-center",
            onClick: fullS
          }, "full screen ")
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(machineListLeftComponent, {
        onSelectMachine: selectMachine,
        onSelectGroup: selectGroup,
        type: 3,
        mode: 1
      })
    ]),
    (_unref(selectType) == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getTranslation)(_unref(machineInfo).machineName)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: "w-full",
                        style: _normalizeStyle([{ color: _unref(machineInfo)?.condition?.color }, {"font-size":"24px","text-align":"center"}])
                      }, _toDisplayString(_unref(langObj)[_unref(machineInfo)?.condition?.label]), 5),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(langObj)['综合健康状态']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: "w-full",
                        style: _normalizeStyle([{ color: _unref(machineInfo)?.status?.color }, {"font-size":"24px","text-align":"center"}])
                      }, _toDisplayString(_unref(langObj)[_unref(machineInfo)?.status?.label]), 5),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(langObj)['当前运行状态']), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[8] || (_cache[8] = _createElementVNode("img", {
                    class: "mr-4",
                    style: {"width":"18px","height":"18px"},
                    src: _imports_0,
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(langObj)['设备信息']), 1)
                ]),
                _createVNode(pictureListComponent, {
                  type: 3,
                  picList: _unref(picListAll)
                }, null, 8, ["picList"]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(langObj)['设备名称']), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(getTranslation)(_unref(machineInfo).machineName)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(langObj)['设备区域']), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(getTranslation)(_unref(getGroupName)(_unref(machineInfo).groupId))), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(langObj)['设备厂家']), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(machineInfo).supplier), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(langObj)['设备编号']), 1),
                    _createElementVNode("div", null, _toDisplayString(_unref(machineInfo).machineCode), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[9] || (_cache[9] = _createElementVNode("img", {
                      class: "mr-4",
                      style: {"width":"18px","height":"18px"},
                      src: _imports_1,
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(langObj)['设备状态占比']), 1)
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                  _createVNode(_component_a_select, {
                    ref: "select",
                    value: _unref(satusTimeDate),
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(satusTimeDate) ? (satusTimeDate).value = $event : satusTimeDate = $event)),
                    style: {"min-width":"120px"},
                    onChange: getMachineStatusTime
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_calendar_outlined),
                            _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(langObj)['近一周']), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 2 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_calendar_outlined),
                            _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(langObj)['近一月']), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      (_unref(visibleChart))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createTextVNode(_toDisplayString(_unref(langObj)['累计运行时间']) + "：", 1),
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(conditionTotal).wkStatsu), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_42, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", {
                          class: "box4",
                          style: {"background-color":"#03b503ff"}
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(langObj)['运行占比']) + " :", 1),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(conditionTotal).wkStatus1Rate) + "%", 1)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"width":"12px"} }, null, -1)),
                        _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(langObj)['运行时间']) + ":", 1),
                        _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(conditionTotal).wkStatus1Date), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _cache[13] || (_cache[13] = _createElementVNode("div", {
                          class: "box4",
                          style: {"background-color":"#1cc48b"}
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(langObj)['健康占比']) + ":", 1),
                        _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(conditionTotal).condition1Rate) + "%", 1)
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"width":"12px"} }, null, -1)),
                        _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(langObj)['健康时间']) + ":", 1),
                        _createElementVNode("div", _hoisted_54, _toDisplayString(_unref(conditionTotal).condition1Date), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", {
                          class: "box4",
                          style: {"background-color":"#ddd246"}
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_57, _toDisplayString(_unref(langObj)['可用占比']) + ":", 1),
                        _createElementVNode("div", _hoisted_58, _toDisplayString(_unref(conditionTotal).condition2Rate) + "%", 1)
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _cache[16] || (_cache[16] = _createElementVNode("div", { style: {"width":"12px"} }, null, -1)),
                        _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(langObj)['可用时间']) + ":", 1),
                        _createElementVNode("div", _hoisted_61, _toDisplayString(_unref(conditionTotal).condition2Date), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _cache[17] || (_cache[17] = _createElementVNode("div", {
                          class: "box4",
                          style: {"background-color":"#cb6a34"}
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_64, _toDisplayString(_unref(langObj)['警戒占比']) + ":", 1),
                        _createElementVNode("div", _hoisted_65, _toDisplayString(_unref(conditionTotal).condition3Rate) + "%", 1)
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _cache[18] || (_cache[18] = _createElementVNode("div", { style: {"width":"12px"} }, null, -1)),
                        _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(langObj)['警戒时间']) + ":", 1),
                        _createElementVNode("div", _hoisted_68, _toDisplayString(_unref(conditionTotal).condition3Date), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _cache[19] || (_cache[19] = _createElementVNode("div", {
                          class: "box4",
                          style: {"background-color":"#b81212"}
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_71, _toDisplayString(_unref(langObj)['故障占比']) + ":", 1),
                        _createElementVNode("div", _hoisted_72, _toDisplayString(_unref(conditionTotal).condition4Rate) + "%", 1)
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _cache[20] || (_cache[20] = _createElementVNode("div", { style: {"width":"12px"} }, null, -1)),
                        _createElementVNode("div", _hoisted_74, _toDisplayString(_unref(langObj)['故障时间']) + ":", 1),
                        _createElementVNode("div", _hoisted_75, _toDisplayString(_unref(conditionTotal).condition4Date), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                _createElementVNode("div", _hoisted_78, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", {
                    class: "circle",
                    style: {"background":"#1cc48b"}
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_79, _toDisplayString(_unref(langObj)['健康']) + "：" + _toDisplayString(_unref(getLanguage)('80分以上')), 1),
                  _cache[22] || (_cache[22] = _createElementVNode("div", {
                    class: "circle ml-8",
                    style: {"background":"#ddd246"}
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_80, _toDisplayString(_unref(langObj)['可用']) + "：" + _toDisplayString(_unref(getLanguage)('60~80分')), 1),
                  _cache[23] || (_cache[23] = _createElementVNode("div", {
                    class: "circle ml-8",
                    style: {"background":"#cb6a34"}
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_81, _toDisplayString(_unref(langObj)['警戒']) + "：" + _toDisplayString(_unref(getLanguage)('30~60分')), 1),
                  _cache[24] || (_cache[24] = _createElementVNode("div", {
                    class: "circle ml-8",
                    style: {"background":"#b81212"}
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_82, _toDisplayString(_unref(langObj)['故障']) + "：" + _toDisplayString(_unref(getLanguage)('30分以下')), 1)
                ]),
                (_unref(isShowSwitch23d))
                  ? (_openBlock(), _createBlock(_component_a_switch, {
                      key: 0,
                      style: {"margin-right":"15px"},
                      checked: _unref(switch23d),
                      "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => (_isRef(switch23d) ? (switch23d).value = $event : switch23d = $event)),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (change23d($event))),
                      "checked-children": '2D',
                      "un-checked-children": '3D'
                    }, null, 8, ["checked"]))
                  : _createCommentVNode("", true)
              ]),
              (isShow3d() && _unref(isShow3DM))
                ? (_openBlock(), _createBlock(D3dViewer, {
                    key: 0,
                    config3d: _unref(config_4d),
                    "machine-id": _unref(machine_id),
                    style: {"margin":"auto auto auto 0"},
                    width: 1000,
                    height: 800
                  }, null, 8, ["config3d", "machine-id"]))
                : _createCommentVNode("", true),
              (isShow2d())
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _createElementVNode("img", {
                      src: _unref(config_3d).picture,
                      style: _normalizeStyle([{"position":"absolute"}, {
              width: _unref(config_3d).img.width + 'px',
              height: _unref(config_3d).img.height + 'px',
              top: _unref(config_3d).img.y + 'px',
              left: _unref(config_3d).img.x + 'px',
              transform: 'rotate(' + _unref(config_3d).img.rotate + 'deg)',
            }])
                    }, null, 12, _hoisted_84),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config_3d).marks, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        (item.bind.indexOf('a-') > -1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "d3_point",
                              style: _normalizeStyle({ top: item.y + 'px', left: item.x + 'px' })
                            }, null, 4))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config_3d).marks, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        (item.bind.indexOf('b-') > -1)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "d3_bq",
                              style: _normalizeStyle([{
                top: item.y - 50 + 'px',
                left: item.x - 100 + 'px',
                'border-color': getColor(item.condition),
                'box-shadow': getShadow(item.condition),
              }, {"width":"225px","height":"100px"}])
                            }, [
                              _createElementVNode("div", _hoisted_85, [
                                _createElementVNode("div", _hoisted_86, [
                                  _createElementVNode("div", null, _toDisplayString(_unref(getTranslation)(item.sensorPlace)), 1),
                                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                                  _createElementVNode("div", {
                                    style: _normalizeStyle([{ 'background-color': getColor2(item.condition) }, {"width":"15px","height":"15px","border-radius":"50%"}])
                                  }, null, 4)
                                ]),
                                _createElementVNode("div", _hoisted_87, [
                                  (isShowQuota(item.dataType, '高频加速度'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                        _createElementVNode("div", null, _toDisplayString(item.hz) + "m/s²", 1),
                                        _createElementVNode("div", _hoisted_89, _toDisplayString(_unref(langObj)['振动加速度']), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (isShowQuota(item.dataType, '速度Z'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                        _createElementVNode("div", null, _toDisplayString(item.sz) + "mm/s", 1),
                                        _createElementVNode("div", _hoisted_91, _toDisplayString(_unref(langObj)['振动速度']), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (isShowQuota(item.dataType, '温度'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                        _createElementVNode("div", null, _toDisplayString(item.temp) + "℃", 1),
                                        _createElementVNode("div", _hoisted_93, _toDisplayString(_unref(langObj)['温度']), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_94, [
                                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                                  _createElementVNode("div", _hoisted_95, _toDisplayString(item.date), 1)
                                ])
                              ])
                            ], 4))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(line), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", {
                          class: "d3_line",
                          style: _normalizeStyle({
                top: item.y + 5 + 'px',
                left: item.x + 5 + 'px',
                width: item.distance + 'px',
                transform: 'rotate(' + item.angle + 'deg)',
              })
                        }, null, 4)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _cache[28] || (_cache[28] = _createElementVNode("img", {
                    style: {"width":"18px","height":"18px"},
                    src: _imports_1,
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_98, _toDisplayString(_unref(langObj)['设备诊断']), 1)
                ]),
                _createElementVNode("div", _hoisted_99, [
                  _cache[29] || (_cache[29] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                  _createElementVNode("div", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (selectTag(1))),
                    class: "btn1 cursor-pointer",
                    style: _normalizeStyle({ background: _unref(selecrRandar) === 1 ? '#171325ff' : '' })
                  }, _toDisplayString(_unref(langObj)['振动指标']), 5),
                  _createElementVNode("div", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (selectTag(2))),
                    class: "btn1 cursor-pointer",
                    style: _normalizeStyle([{ background: _unref(selecrRandar) === 2 ? '#171325ff' : '' }, {"margin-left":"10px"}])
                  }, _toDisplayString(_unref(langObj)['健康指标']), 5),
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (selectTag(3))),
                    class: "btn1 cursor-pointer",
                    style: _normalizeStyle([{"margin-left":"10px"}, { background: _unref(selecrRandar) === 3 ? '#171325ff' : '' }])
                  }, _toDisplayString(_unref(langObj)['分数趋势']), 5),
                  _cache[30] || (_cache[30] = _createElementVNode("div", { class: "flex-1" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                  (_unref(visibleChart2))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_101))
                    : _createCommentVNode("", true),
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "flex-1" }, null, -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_102, [
                _createVNode(WorkflowWidget, {
                  ref: "orderC",
                  machineInfo: _unref(machineInfo)
                }, null, 8, ["machineInfo"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(selectType) == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("span", _hoisted_105, _toDisplayString(_unref(group_info).name), 1)
          ]),
          _createElementVNode("div", _hoisted_106, [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(group_machineList_page), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "group-box mt-3 p-2",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_107, [
                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "shu" }, null, -1)),
                    _createElementVNode("div", _hoisted_108, _toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("img", {
                        style: {"width":"100%","max-height":"100%"},
                        src: item.picture,
                        alt: ""
                      }, null, 8, _hoisted_111)
                    ]),
                    _createElementVNode("div", _hoisted_112, [
                      (item.scoreWkStatus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "line" }, [
                              _createElementVNode("div", { class: "line animation" })
                            ], -1)),
                            _createElementVNode("span", _hoisted_114, _toDisplayString(_unref(langObj)['运行']), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_115, [
                            _cache[35] || (_cache[35] = _createElementVNode("div", { class: "down" }, [
                              _createElementVNode("div", { class: "down animation" })
                            ], -1)),
                            _createElementVNode("span", _hoisted_116, _toDisplayString(_unref(langObj)['停机']), 1)
                          ])),
                      _createElementVNode("div", _hoisted_117, [
                        _createElementVNode("div", {
                          class: "line",
                          style: _normalizeStyle({ 'background-color': item?.condition?.color })
                        }, [
                          _createElementVNode("div", {
                            class: "line animation",
                            style: _normalizeStyle({ 'background-color': item?.condition?.color })
                          }, null, 4)
                        ], 4),
                        _createElementVNode("span", _hoisted_118, _toDisplayString(item?.condition?.label), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              _createVNode(_component_a_pagination, {
                style: {"margin-top":"15px"},
                onChange: changePage,
                current: _unref(searchPage).skip,
                "onUpdate:current": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchPage).skip) = $event)),
                pageSize: _unref(searchPage).take,
                "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchPage).take) = $event)),
                simple: "",
                total: _unref(searchPage).total
              }, null, 8, ["current", "pageSize", "total"])
            ]),
            _createElementVNode("div", _hoisted_119, [
              _cache[37] || (_cache[37] = _createElementVNode("div", { style: {"width":"10%"} }, null, -1)),
              _createElementVNode("div", _hoisted_120, [
                (_unref(config_3d_group) && _unref(config_3d_group).img)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                      _createElementVNode("img", {
                        src: _unref(config_3d_group).picture,
                        style: _normalizeStyle([{"position":"absolute"}, {
                    width: _unref(config_3d_group).img.width + 'px',
                    height: _unref(config_3d_group).img.height + 'px',
                    top: _unref(config_3d_group).img.y + 'px',
                    left: _unref(config_3d_group).img.x + 'px',
                    transform: 'rotate(' + _unref(config_3d_group).img.rotate + 'deg)',
                  }])
                      }, null, 12, _hoisted_122),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config_3d_group).marks, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          (item.bind.indexOf('a-') > -1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "d3_point",
                                style: _normalizeStyle({ top: item.y + 'px', left: item.x + 'px' })
                              }, null, 4))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config_3d_group).marks, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          (item.bind.indexOf('b-') > -1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "d3_bq",
                                style: _normalizeStyle([{
                  top: item.y - 50 + 'px',
                  left: item.x - 100 + 'px',
                  'border-color': getColor(0),
                }, {"width":"220px","height":"auto"}])
                              }, [
                                _createElementVNode("div", _hoisted_123, [
                                  _createElementVNode("div", _hoisted_124, [
                                    _createElementVNode("div", _hoisted_125, _toDisplayString(_unref(group_info)?.name), 1)
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(group_machineList), (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: "w-full flex items-center"
                                    }, [
                                      _createElementVNode("div", null, _toDisplayString(item.name), 1),
                                      _cache[36] || (_cache[36] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                                      _createElementVNode("div", {
                                        style: _normalizeStyle([{"width":"16px","height":"16px","border-radius":"50%","min-width":"16px"}, { 'background': item.condition.color }])
                                      }, null, 4)
                                    ]))
                                  }), 128))
                                ])
                              ], 4))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lineGroup), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", {
                            class: "d3_line",
                            style: _normalizeStyle({
                  top: item.y + 5 + 'px',
                  left: item.x + 5 + 'px',
                  width: item.distance + 'px',
                  transform: 'rotate(' + item.angle + 'deg)',
                })
                          }, null, 4)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})